import React from 'react';
import { ClockIcon, GlobeIcon, MailIcon, MapIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { Seo } from '../components/Seo';
import { ButtonLink, Eyebrow, Heading, NextPage, Prose, Section, TextLink } from '../components/ui';
import { images, site, socials } from '../data/site';
export function Contact() {
  return <>
      <Seo title="Contact LeonDesign | Spaans Neerbeek 25, 6164 CH Geleen" description="Contactgegevens van LeonDesign in Geleen: telefoon 06-11087851, e-mail info@leondesign.nl, adres Spaans Neerbeek 25 en een webshop die 24/7 bereikbaar is." data-id="element-210" data-mp="1lo71u8npcyid" />

      <Section className="pt-12 sm:pt-16" data-id="element-211" data-mp="17radcdv23t4n">
        <div className="max-w-3xl" data-id="element-212" data-mp="17sbr4q3gitq2">
          <Eyebrow data-id="element-213" data-mp="12ziihr4vb18p">Contact</Eyebrow>
          <h1 className="font-display text-4xl font-semibold leading-[1.1] tracking-tight text-ink sm:text-5xl" data-id="element-214" data-mp="12yh7tnrrkgri">
            Neem contact op met LeonDesign in Geleen
          </h1>
          <p className="mt-6 text-lg leading-relaxed text-cocoa/90" data-id="element-215" data-mp="aabliwl2ajpk">
            Heeft u een vraag over een portemonnee, een pasjeshouder of een zakelijke bestelling
            horeca lederwaren? Bellen gaat het snelst, e-mailen mag uiteraard ook. Vermeld bij een
            e-mail kort waarvoor u het artikel gaat gebruiken, dan is een gericht antwoord mogelijk.
          </p>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-[1.1fr_1fr]" data-id="element-216" data-mp="1j5sea5mwtzz5">
          <div className="rounded-3xl border border-cocoa/12 bg-paper p-6 sm:p-9" data-id="element-217" data-mp="mguiql7c5y0x">
            <div className="flex items-start gap-4" data-id="element-218" data-mp="qi694sy1ana6">
              <img src={images.logo} alt="Logo van LeonDesign, lederwarenspecialist uit Geleen" className="h-16 w-16 rounded-2xl border border-cocoa/10 object-cover" width={64} height={64} data-id="element-219" data-mp="qixw5fdkfcou" />
              <div data-id="element-220" data-mp="26vcwunf5iv7w">
                <h2 className="font-display text-2xl font-semibold text-ink" data-id="element-221" data-mp="26vwc1wdf35i8">{site.name}</h2>
                <p className="mt-1 text-[15px] text-cocoa/75" data-id="element-222" data-mp="2btxwolqhrcvt">Lederwaren · webshop &amp; vestiging</p>
              </div>
            </div>

            <dl className="mt-8 space-y-6" data-id="element-223" data-mp="1h8ahypk50vn8">
              <div className="flex gap-4" data-id="element-224" data-mp="1h78vzq1l2oqq">
                <MapPinIcon className="mt-1 h-5 w-5 shrink-0 text-pine" aria-hidden="true" data-id="element-225" data-mp="1hamwstulmpw2" />
                <div data-id="element-226" data-mp="1w3gn7abesqfi">
                  <dt className="text-sm font-semibold uppercase tracking-wide text-cocoa/60" data-id="element-227" data-mp="1r6gfyw2tphmt">
                    Adres
                  </dt>
                  <dd className="mt-1 text-[17px] leading-relaxed text-ink" data-id="element-228" data-mp="13hnkf0q45bsq">
                    <address className="not-italic" data-id="element-229" data-mp="yikcn8ir0rh2">
                      {site.street}
                      <br data-id="element-230" data-mp="1d77428lnh9on" />
                      {site.postal} {site.city}
                      <br data-id="element-231" data-mp="18fyt384o9g9d" />
                      {site.province}, {site.country}
                    </address>
                  </dd>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-232" data-mp="kojof8pfamuy">
                <PhoneIcon className="mt-1 h-5 w-5 shrink-0 text-pine" aria-hidden="true" data-id="element-233" data-mp="frt7kj5snn8h" />
                <div data-id="element-234" data-mp="2rewo9pep47xn">
                  <dt className="text-sm font-semibold uppercase tracking-wide text-cocoa/60" data-id="element-235" data-mp="2red9uio981od">
                    Telefoon
                  </dt>
                  <dd className="mt-1 text-[17px] text-ink" data-id="element-236" data-mp="2w7g3srwy1d53">
                    <a href={site.phoneHref} className="underline decoration-cocoa/30 underline-offset-4 hover:decoration-cocoa" data-id="element-237" data-mp="2hhicw47mq9c7">
                      {site.phone}
                    </a>
                  </dd>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-238" data-mp="3f3pf57ggnple">
                <MailIcon className="mt-1 h-5 w-5 shrink-0 text-pine" aria-hidden="true" data-id="element-239" data-mp="314q08rir2p2f" />
                <div data-id="element-240" data-mp="3561g45btnvxf">
                  <dt className="text-sm font-semibold uppercase tracking-wide text-cocoa/60" data-id="element-241" data-mp="355i7xgbz4lwl">
                    E-mail
                  </dt>
                  <dd className="mt-1 text-[17px] text-ink" data-id="element-242" data-mp="1pnzqwzj15h4l">
                    <a href={`mailto:${site.email}`} className="underline decoration-cocoa/30 underline-offset-4 hover:decoration-cocoa" data-id="element-243" data-mp="1tr4p4pw2uwnf">
                      {site.email}
                    </a>
                  </dd>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-244" data-mp="208r2cm7zrmzg">
                <ClockIcon className="mt-1 h-5 w-5 shrink-0 text-pine" aria-hidden="true" data-id="element-245" data-mp="1v94n678lrwo0" />
                <div data-id="element-246" data-mp="2swvarfhy6e5u">
                  <dt className="text-sm font-semibold uppercase tracking-wide text-cocoa/60" data-id="element-247" data-mp="2sxesav3or0jc">
                    Openingstijden
                  </dt>
                  <dd className="mt-1 text-[17px] text-ink" data-id="element-248" data-mp="2nylhxbjp3pne">
                    {site.hours} — de webshop is dag en nacht bereikbaar
                  </dd>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-249" data-mp="2ewu7jte7mun7">
                <GlobeIcon className="mt-1 h-5 w-5 shrink-0 text-pine" aria-hidden="true" data-id="element-250" data-mp="17k1zahndl7l2" />
                <div data-id="element-251" data-mp="13i6yde9cww7t">
                  <dt className="text-sm font-semibold uppercase tracking-wide text-cocoa/60" data-id="element-252" data-mp="13gvvrhrnduia">
                    Website
                  </dt>
                  <dd className="mt-1 text-[17px] text-ink" data-id="element-253" data-mp="3f37kdn65uzlx">
                    <a href={site.website} target="_blank" rel="noopener noreferrer" className="underline decoration-cocoa/30 underline-offset-4 hover:decoration-cocoa" data-id="element-254" data-mp="3j7p0ncdbaury">
                      leondesign.nl
                    </a>
                  </dd>
                </div>
              </div>
            </dl>

            <div className="mt-9 flex flex-wrap gap-3" data-id="element-255" data-mp="6nxmkr9b0gjy">
              <ButtonLink href={site.phoneHref} data-id="element-256" data-mp="aqkj35gx6pnh">Bel {site.phone}</ButtonLink>
              <ButtonLink href={`mailto:${site.email}`} variant="secondary" data-id="element-257" data-mp="fq6rn1lszhpy">
                Stuur een e-mail
              </ButtonLink>
              <ButtonLink href={site.website} variant="secondary" data-id="element-258" data-mp="2cjiftcdti2dp">
                Naar de webshop
              </ButtonLink>
            </div>

            <div className="mt-8 border-t border-cocoa/15 pt-6 text-[15px] text-cocoa/75" data-id="element-259" data-mp="2hjmnqe0ntosb">
              <p data-id="element-260" data-mp="3kujwo6j03ekw">
                KVK: {site.kvk} · BTW: {site.btw}
              </p>
            </div>
          </div>

          <div className="space-y-6" data-id="element-261" data-mp="3tt49ws5skw1q">
            <div className="rounded-3xl bg-sand/70 p-6 sm:p-9" data-id="element-262" data-mp="3tu6zmwrdosg2">
              <Heading level={3} data-id="element-263" data-mp="3ou14v7ptaptr">Waarmee kunnen wij u helpen?</Heading>
              <Prose className="mt-4" data-id="element-264" data-mp="3osq31dfxfs5a">
                <p data-id="element-265" data-mp="7le4sj903st1">
                  De meeste vragen gaan over de indeling van een portemonnee, het formaat van een
                  heuptasje of de mogelijkheden voor een horecateam. Geef bij uw bericht aan om
                  hoeveel personen het gaat en hoe intensief het artikel gebruikt wordt.
                </p>
                <p data-id="element-266" data-mp="cdp5vpfh9kn6">
                  Weet u nog niet welk type product u zoekt? Neem dan eerst de{' '}
                  <TextLink to="/collectie" data-id="element-267" data-mp="qd6y6erzfg1a">collectie per categorie</TextLink> door — daar staat per
                  productgroep beschreven voor wie die bedoeld is.
                </p>
              </Prose>
            </div>

            <div className="rounded-3xl border border-cocoa/12 bg-paper p-6 sm:p-9" data-id="element-268" data-mp="14zvte4f7b71v">
              <Heading level={3} data-id="element-269" data-mp="19xp0r0s8q73q">Volg LeonDesign online</Heading>
              <p className="mt-3 text-[16px] leading-relaxed text-cocoa/85" data-id="element-270" data-mp="v1g6yer4clyp">
                Nieuwe modellen en foto’s van het assortiment verschijnen op de sociale kanalen van
                het bedrijf.
              </p>
              <ul className="mt-5 flex flex-wrap gap-3" data-id="element-271" data-mp="m7uq8pve8umn">
                {socials.map(s => <li key={s.href} data-id="element-272" data-mp="r04nys2r2yzh">
                    <a href={s.href} target="_blank" rel="noopener noreferrer" className="inline-block rounded-full border border-cocoa/20 px-5 py-2.5 text-[15px] font-medium text-cocoa transition-colors duration-150 ease-out hover:border-pine hover:text-pine" data-id="element-273" data-mp="r15z0wjrnlh7">
                      {s.label}
                    </a>
                  </li>)}
              </ul>
              <p className="mt-5 text-[15px] leading-relaxed text-cocoa/75" data-id="element-274" data-mp="nq3c2u5kykd7">
                Overige vermeldingen en bedrijfsprofielen staan gebundeld op de{' '}
                <TextLink to="/bronnen" data-id="element-275" data-mp="drnlcsagtd48">bronnenpagina</TextLink>.
              </p>
            </div>
          </div>
        </div>
      </Section>

      {/* Locatie */}
      <Section className="pt-20 sm:pt-24" data-id="element-276" data-mp="4s0j649ww3a4">
        <div className="max-w-2xl" data-id="element-277" data-mp="4ssgbjj5q92i">
          <Eyebrow data-id="element-278" data-mp="4ttrdo06avk8">Locatie</Eyebrow>
          <Heading data-id="element-279" data-mp="qup703n5zt">Spaans Neerbeek 25, Geleen</Heading>
          <p className="mt-4 text-[17px] leading-relaxed text-cocoa/85" data-id="element-280" data-mp="3w4leogcr57pf">
            De vestiging ligt in Geleen, gemeente Sittard-Geleen, in Zuid-Limburg. Vanuit Sittard,
            Beek, Stein en Elsloo is het adres binnen enkele minuten te bereiken. Bestellingen
            worden via de webshop afgehandeld; kom voor een bezoek altijd eerst even bellen.
          </p>
        </div>

        <div className="mt-8 rounded-3xl border border-dashed border-cocoa/30 bg-paper p-6 sm:p-10" aria-labelledby="kaart-titel" data-id="element-281" data-mp="3d8lvnv1r5ehz">
          <div className="flex flex-col items-start gap-5 sm:flex-row sm:items-center" data-id="element-282" data-mp="1wqlhbbsbc8tk">
            <span className="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-sand" data-id="element-283" data-mp="21py6422qvpys">
              <MapIcon className="h-6 w-6 text-pine" aria-hidden="true" data-id="element-284" data-mp="26psw83ep4bis" />
            </span>
            <div data-id="element-285" data-mp="192alin1h4zc5">
              <h3 id="kaart-titel" className="font-display text-xl font-semibold text-ink" data-id="element-286" data-mp="192tydpc9oxjb">
                Kaartweergave — nog in te vullen
              </h3>
              <p className="mt-2 max-w-2xl text-[16px] leading-relaxed text-cocoa/85" data-id="element-287" data-mp="1j08bbeyzf46v">
                Voor deze microsite is geen geverifieerde Google Business Profile- of Google
                Maps-URL van LeonDesign aangeleverd. Om te voorkomen dat hier een onjuiste locatie
                komt te staan, is bewust geen kaart ingesloten. Zodra de officiële embed-code of
                Maps-link bekend is, kan die hier één-op-één worden geplaatst.
              </p>
              <p className="mt-3 text-[15px] text-cocoa/70" data-id="element-288" data-mp="ozoojp0qpfu8">
                Adres van de vestiging: {site.street}, {site.postal} {site.city}, {site.province},{' '}
                {site.country}.
              </p>
            </div>
          </div>

          {/*
            KAART INVOEGEN:
            Vervang dit blok door de geverifieerde Google Maps-embed van LeonDesign, bijvoorbeeld:
            <iframe title="Locatie van LeonDesign in Geleen" src="GEVERIFIEERDE_GOOGLE_MAPS_EMBED_URL"
              className="h-[420px] w-full rounded-2xl border-0" loading="lazy"
              referrerPolicy="no-referrer-when-downgrade" />
           */}
        </div>
      </Section>

      <Section className="pt-16" data-id="element-289" data-mp="kxjyt1dex3cv">
        <div className="grid gap-4 md:grid-cols-3" data-id="element-290" data-mp="kxtsp01kvunu">
          <NextPage to="/" label="Terug naar de homepage" description="Overzicht van LeonDesign en de belangrijkste productgroepen." data-id="element-291" data-mp="3jl7pac11y7hd" />
          <NextPage to="/over-ons" label="Over LeonDesign" description="Achtergrond van de lederwarenspecialist uit Geleen en de klantgroepen." data-id="element-292" data-mp="25q92c77uycbs" />
          <NextPage to="/collectie" label="Collectie bekijken" description="Portemonnees, pasjeshouders, horeca lederwaren, riemen en accessoires." data-id="element-293" data-mp="1woro6ue0gkpq" />
        </div>
      </Section>
    </>;
}